var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareSalesMultiChannelCampaigns = function SvgYeswareSalesMultiChannelCampaigns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.988,
    width: 80,
    height: 80,
    rx: 19.422,
    fill: "#E7F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.59 23.666a1.597 1.597 0 0 0-3.193 0v1.236L27.412 34.26a.797.797 0 0 0-.552.76v9.511a.799.799 0 0 0 .559.761l2.075.652a.798.798 0 0 1 .56.761v4.137a7.193 7.193 0 0 0 7.184 7.153h.033a7.193 7.193 0 0 0 7.152-7.212v-.16l11.974 3.753v1.223a1.597 1.597 0 0 0 3.194 0V23.666ZM41.23 50.791a3.99 3.99 0 0 1-3.973 4.011h-.02a3.991 3.991 0 0 1-3.99-3.966v-2.63a.799.799 0 0 1 1.037-.761l6.387 2.002a.798.798 0 0 1 .558.761v.583ZM24.465 34.045a1.597 1.597 0 1 0-3.193 0l.008 11.176a1.597 1.597 0 0 0 1.597 1.597h-.008a1.596 1.596 0 0 0 1.596-1.559V34.045Z",
    fill: "#039BE5"
  })));
};
export default SvgYeswareSalesMultiChannelCampaigns;